import axios from 'axios'

export const baseURL = process.env.VUE_APP_WEB_API

const http = axios.create({
  baseURL,
  withCredentials: false
})

http.interceptors.request.use((config) => {
  config.headers = {
    'X-Socket-ID': window.Echo.socketId(),
    ...config.headers
  }
  if (localStorage.access_token) {
    config.headers.Authorization = `Bearer ${localStorage.access_token}`
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

http.interceptors.response.use((response) => response, (error) => {
  if (error.response.status === 401) {
    localStorage.clear()
    window.location.href = '/'
  }
  return Promise.reject(error)
})

export {
  http
}
